var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 6,
    viewBox: "0 0 9 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.38058 5.35283C4.0122 5.35283 3.66047 5.19567 3.41457 4.92172L0.285034 1.74542C-0.00784685 1.42563 -0.078558 0.998396 0.0893239 0.617924C0.257206 0.236997 0.619658 0 1.03571 0H7.7243C8.1399 0 8.50281 0.23654 8.67024 0.617468C8.83766 0.998396 8.76763 1.42517 8.4873 1.73219L5.33062 4.9386C5.10001 5.19544 4.74805 5.35329 4.38035 5.35329V5.35283H4.38058Z",
    fill: "#C3C3C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.77775ff86f4bbf1f4034a1a333ab7f90.svg";
export { ForwardRef as ReactComponent };